import { Delivery } from "../models/Delivery";
import PlotAPI from "../plotAPI";

interface useDeliveriesProps {
    projects: any[];
    projectInfo: (projectId: string | number) => any | null;
    overrideTimezone: string | null;
}

const useDeliveries = (props: useDeliveriesProps) => {
    const createDelivery = (newDelivery: Delivery): Promise<Delivery | null> => {
        if (!newDelivery.projectId) {
            return Promise.resolve(null);
        }

        const project = props.projectInfo(newDelivery.projectId);

        if (!project) {
            return Promise.resolve(null);
        }

        return PlotAPI.createDelivery(
            project.claimed_by_team_subdomain || "projects",
            project.unique_token,
            newDelivery
        );
    };

    const updateDelivery = (updatedDelivery: Delivery) => {
        if (!updatedDelivery.projectId) {
            return Promise.resolve(null);
        }

        const project = props.projectInfo(updatedDelivery.projectId);

        if (!project) {
            return Promise.resolve(null);
        }

        return PlotAPI.updateDelivery(
            project.claimed_by_team_subdomain || "projects",
            project.unique_token,
            updatedDelivery
        );
    };

    const deleteDelivery = (deliveryToDelete: Delivery): Promise<boolean> => {
        if (!deliveryToDelete.projectId) {
            return Promise.resolve(false);
        }

        const project = props.projectInfo(deliveryToDelete.projectId);

        if (!project) {
            return Promise.resolve(false);
        }

        return PlotAPI.deleteDelivery(
            project.claimed_by_team_subdomain || "projects",
            project.unique_token,
            deliveryToDelete
        );
    };

    return {
        createDelivery,
        updateDelivery,
        deleteDelivery,
    };
};

export default useDeliveries;
